import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
const PREFIX = 'BrandingStatsCan';

const classes = {
  brandImageGroup: `${PREFIX}-brandImageGroup`,
  brandImage: `${PREFIX}-brandImage`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.brandImageGroup}`]: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },

  [`& .${classes.brandImage}`]: {
    'maxHeight': '100%',
    'height': theme.spacing(2.5),
    'width': 'auto',
    '&:not(:last-child)': {
      marginRight: theme.spacing(2.5),
    },
  }
}));

export default function BrandingStatsCan(props) {
  const {t} = useTranslation();

  return (
    (<Root>
      <div className={classes.brandImageGroup}>
        <img
          src={process.env.STATIC_URL + '/images/StatisticsCanadaLogoFlag.svg'}
          alt={t("site.brandingAlt")}
          className={classes.brandImage}
        />
        <img
          src={process.env.STATIC_URL + '/images/StatisticsCanadaLogoTextEN.svg'}
          alt=""
          className={classes.brandImage}
        />
        <img
          src={process.env.STATIC_URL + '/images/StatisticsCanadaLogoTextFR.svg'}
          alt=""
          className={classes.brandImage}
        />
      </div>
    </Root>)
  );
}
BrandingStatsCan.propTypes={
  handleSaveBeforeLeave: PropTypes.func,
};